// What kind of thing a share or a recording is, and the section of /shares
// it is listed in (byj-1wv.45): a tmux terminal, or an agent — byj, Claude
// Code, Codex, or a byj agent served over A2A. Recordings are their own
// section, and carry the kind they were recorded from.
import type { Source } from "./protocol";

export type Section = "terminals" | "agents";

/** The relay's sources, as the protocol names them; older names read as theirs. */
export function kindOf(source: string): Source {
  const s = ({ jolt: "byj", "claude-code": "claude" } as Record<string, string>)[source] ?? source;
  return (["byj", "claude", "codex", "agent", "term"].includes(s) ? s : "byj") as Source;
}

export const sectionOf = (source: string): Section => (kindOf(source) === "term" ? "terminals" : "agents");

/** The agent kinds, in the order their chips stand. */
export const agentKinds: Source[] = ["byj", "claude", "codex", "agent"];

export const kindIcon: Record<Source, string> = { term: ">_", byj: "◆", claude: "✻", codex: "▣", agent: "⇄" };

/** Live first, then the newest: one that has ended by when it ended, as its row says it (byj-fym), the rest by when they started. */
export function liveThenNewest<T extends { live?: boolean; started_at?: string; ended_at?: string; created_at?: string }>(a: T, b: T): number {
  if (Boolean(a.live) !== Boolean(b.live)) return a.live ? -1 : 1;
  const at = (x: T) => Date.parse(x.ended_at ?? x.started_at ?? x.created_at ?? "");
  return at(b) - at(a);
}
